import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Collection.css";
import WebsiteFooter from "../components/WebsiteFooter";
import Card from "../components/Card";

const Collections = ({ productsData, addToCart, products }) => {
  const navigate = useNavigate();

  const handleNavigation = (product) => {
    const timestamp = new Date().toISOString();
    window.gtag("event", `All_${product}_viewed`, { 'timestamp': timestamp.toLocaleString(), "click": product })
    navigate(`/Product/${product}`);
  };

  return (
    <>
      <div className="collections-container">
        <h1>All Products</h1>
        <div className="items-grid">
          {productsData && productsData.length > 0 ? (
            productsData.map((item, index) => (
              // <Card key={index} item={item}  onClick={() => handleNavigation(`/Product/${item.Name}`)} />
              <Card
                key={index}
                item={item}
                addToCart={addToCart}
                onClick={() => handleNavigation(item.Name)}
                products={products}
              />
            ))
          ) : (
            <p>No items available</p>
          )}
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
};

export default Collections;
